import { defineMessages } from 'react-intl';

export const messages: {
	teamLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	avatarLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	teamLabel: {
		id: 'team',
		defaultMessage: 'Team',
		description: 'Team label text',
	},
	avatarLabel: {
		id: 'avatar',
		defaultMessage: 'Avatar',
		description: 'Avatar label text',
	},
});
